import React, { useContext, useState } from 'react';
import '../../../stylesheets/stylesComponents/copy-on-hover.scss';
import { NotificationsContext } from '../../../contexts/NotificationsContext';
import useTranslate from '../../../customHooks/useTranslate';
import Icon from '../../../muiComponents/Icon';

const CopyOnHover = ({ textToCopy, children, className = '' }) => {
    const translate = useTranslate();
    const { setErrorMessage, setSuccessMessage } =
        useContext(NotificationsContext);
    const [hovered, setHovered] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setSuccessMessage(translate('copied'));
        } catch (error) {
            console.error(error);
            setErrorMessage(translate('default_server_error'));
        }
    };

    return (
        <div
            className={`copy-on-hover__container ${className}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className='copy-on-hover__content'>{children}</div>
            {hovered && (
                <Icon
                    iconName='ContentCopy'
                    className='copy-on-hover__icon'
                    onClick={handleCopy}
                />
            )}
        </div>
    );
};

export default CopyOnHover;
